module.exports = __webpack_public_path__ + "static/media/load.97f1a914.png";